__turbopack_context__.v({
  "className": "Wd6kja_className",
  "variable": "Wd6kja_variable",
});
